import { E2eLocators } from "@onsip/e2e/configs/locators";
import { views } from "@onsip/web/app/phone/views";

export const InboundCallSettingsNav = {
  name: "Inbound call settings",
  cyLocator: E2eLocators.ADMIN_INBOUND_CALL_SETTINGS_TAB,
  nestedUrls: [
    {
      name: "ACD queues",
      url: views.ADMIN_ACD_QUEUES,
      cyLocator: E2eLocators.ADMIN_ACD_QUEUES
    },
    {
      name: "Announcements",
      url: views.ADMIN_ADV_ANNOUNCEMENTS,
      cyLocator: E2eLocators.NAV_ADMINS_ANNOUNCEMENTS
    },
    {
      name: "Attendant menu",
      url: views.ADMIN_ATTENDANT_MENU,
      cyLocator: E2eLocators.NAV_ADMINS_ATT_MENU
    },
    {
      name: "Business hour rules",
      url: views.ADMIN_BHR,
      cyLocator: E2eLocators.ADMIN_BUSINESS_HOUR_RULES_PAGE_LINK
    },
    {
      name: "Call recording",
      url: views.ADMIN_RECORDING_RULES,
      cyLocator: E2eLocators.NAV_ADMINS_CALL_RECORDING
    },
    {
      name: "Conference suite",
      url: views.ADMIN_CONFERENCE_SUITE,
      cyLocator: E2eLocators.NAV_ADMINS_CONFERENCE_SUITE
    },
    {
      name: "Dial-by-name directory",
      url: views.ADMIN_DBN_DIRECTORY,
      cyLocator: E2eLocators.NAV_ADMINS_DBN_DIRECTORY
    },
    {
      name: "Groups",
      url: views.GROUPS,
      cyLocator: E2eLocators.NAV_ADMINS_GROUPS
    },
    {
      name: "Inbound bridge",
      url: views.ADMIN_INBOUND_BRIDGE,
      cyLocator: E2eLocators.NAV_ADMINS_INBOUND_BRIDGE
    },
    {
      name: "Music on hold",
      url: views.ADMIN_MUSIC_ON_HOLD,
      cyLocator: E2eLocators.NAV_ADMINS_MUSIC_ON_HOLD
    },
    {
      name: "Parking lot",
      url: views.ADMIN_PARKING_LOT,
      cyLocator: E2eLocators.ADMIN_PARKING_LOT_BUTTON
    },
    {
      name: "Recording library",
      url: views.ADMIN_RECORDING
    },
    {
      name: "Voicemail",
      url: views.ADMIN_VOICEMAIL,
      cyLocator: E2eLocators.NAV_ADMINS_VOICEMAILS
    }
  ]
};

export const OrgAdminInboundCallSettingsNav = () => {
  const inboundCallSettings = JSON.parse(JSON.stringify(InboundCallSettingsNav));
  const nestedUrls = inboundCallSettings["nestedUrls"];
  const mohIndex = nestedUrls.findIndex((url: { name: string }) => url.name === "Music on hold");
  nestedUrls.splice(mohIndex, 1);
  return inboundCallSettings;
};

export const OutboundCallSettingsNav = {
  name: "Outbound call settings",
  cyLocator: E2eLocators.NAV_ADMINS_OUTBOUND_CALLS,
  nestedUrls: [
    {
      name: "E911",
      url: views.E911_TABLE
    },
    {
      name: "External SIP address",
      url: views.ADMIN_EXTERNAL_ADDRESS,
      cyLocator: E2eLocators.NAV_ADMINS_EXTERNAL_SIP_ADDRESS
    },
    {
      name: "External phone number",
      url: views.ADMIN_EXTERNAL_PHONE_NUMBER,
      cyLocator: E2eLocators.NAV_ADMINS_EXTERNAL_PHONE_NUMBER
    }
  ]
};

export const OrgAdminOutboundCallSettingsNav = () => {
  const outboundCallSettings = JSON.parse(JSON.stringify(OutboundCallSettingsNav));
  const nestedUrls = outboundCallSettings["nestedUrls"];
  const e911Index = nestedUrls.findIndex(
    (url: { name: string; url: string; cyLocator: string }) => url.name === "E911"
  );
  nestedUrls.splice(e911Index, 1);
  return outboundCallSettings;
};

export const PBXSettingsNav = {
  name: "PBX settings",
  nestedUrls: [
    {
      name: "PBX Contact",
      url: views.ADMIN_PBX_SETTINGS_CONTACT
    },
    {
      name: "Blocked numbers",
      url: views.ADMIN_PBX_SETTINGS_BLOCKED_NUMBERS
    },
    {
      name: "Default caller ID",
      url: views.ADMIN_PBX_SETTINGS_DEFAULT_CALLER_ID
    },
    {
      name: "Enabled services",
      url: views.ADMIN_PBX_SETTINGS_ENABLED_SERVICES
    },
    {
      name: "Migrate SIP domain",
      url: views.ADMIN_PBX_SETTINGS_MIGRATE_SIP_DOMAIN
    },
    {
      name: "Multi-factor authentication",
      url: views.ADMIN_PBX_SETTINGS_MULTI_FACTOR_AUTHENTICATION
    },
    {
      name: "Recording manager",
      url: views.ADMIN_PBX_SETTINGS_RECORDING_MANAGER
    },
    {
      name: "Storage service",
      url: views.ADMIN_PBX_SETTINGS_STORAGE_SERVICE
    },
    {
      name: "Voicemail manager",
      url: views.ADMIN_PBX_SETTINGS_VOICEMAIL_MANAGER
    }
  ]
};

export const OrgAdminPBXSettingsNav = () => {
  const pbxSettings = JSON.parse(JSON.stringify(PBXSettingsNav));
  const nestedUrls = pbxSettings["nestedUrls"];
  const enabledServicesIndex = nestedUrls.findIndex(
    (url: { name: string; url: string }) => url.name === "Enabled services"
  );
  nestedUrls.splice(enabledServicesIndex, 1);
  return pbxSettings;
};

export const ShellNavigations = [
  {
    name: "Overview",
    url: views.ADMIN_PBX_OVERVIEW
  },
  {
    name: "Users",
    url: views.USERS,
    cyLocator: E2eLocators.NAV_ADMINS_USERS_LINK
  },
  {
    name: "Phones",
    url: views.PHONES
  },
  {
    name: "Phone numbers",
    url: views.PHONE_NUMBERS
  },
  InboundCallSettingsNav,
  OutboundCallSettingsNav,
  {
    name: "Directory",
    url: views.ADMIN_DIRECTORY
  },
  {
    name: "Reports",
    url: views.ADMIN_REPORTS
  },
  PBXSettingsNav
];

export const OrgAdminShellNavigations = [
  {
    name: "Overview",
    url: views.ADMIN_PBX_OVERVIEW
  },
  {
    name: "Users",
    url: views.USERS,
    cyLocator: E2eLocators.NAV_ADMINS_USERS_LINK
  },
  {
    name: "Phones",
    url: views.PHONES
  },
  OrgAdminInboundCallSettingsNav(),
  OrgAdminOutboundCallSettingsNav(),
  {
    name: "Directory",
    url: views.ADMIN_DIRECTORY
  },
  OrgAdminPBXSettingsNav()
];
